// extracted by mini-css-extract-plugin
export default {"item":"Overlay-module--item--d3cf3"};